import styled from 'styled-components';
import React from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { u as useTabs } from './index.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TabViewer$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var dataAttributes = useDataAttributes(rest);

  var _useTabs = useTabs(),
      tabs = _useTabs.tabs;

  var activeTab = tabs.find(function (el) {
    return el.isActive;
  });
  return /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({
    "aria-labelledby": activeTab === null || activeTab === void 0 ? void 0 : activeTab.id,
    id: "".concat(activeTab === null || activeTab === void 0 ? void 0 : activeTab.id, "-viewer"),
    ref: ref,
    className: "gz-viewer ".concat(className),
    role: "tabpanel",
    tabIndex: "0" // eslint-disable-next-line react/jsx-props-no-spreading

  }, dataAttributes), {}, {
    children: activeTab && activeTab.viewer
  }));
});
TabViewer$1.COMPONENT_ID = 'Gearz.Tabs.TabViewer';
TabViewer$1.displayName = TabViewer$1.COMPONENT_ID;
TabViewer$1.propTypes = {
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  id: PropTypes.stringWithDescription('Id of the viewer.')
};
TabViewer$1.defaultProps = {
  className: '',
  id: null
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var TabViewer = styled(TabViewer$1).withConfig({
  componentId: "gz-tabs-1679041987883__sc-1ltktik-0"
})(["flex:1;padding:8px;position:relative;"]);
TabViewer.displayName = TabViewer$1.displayName;
TabViewer.propTypes = TabViewer$1.propTypes;
TabViewer.defaultProps = TabViewer$1.defaultProps;

export { TabViewer as T };
